import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
//#endregion
//#region components
import {
  PageLayouts,
  useMountedState,
  useNavigationHistory,
  useAPIRequestKeyRef,
  EntityCardLayout,
  Skeletons,
  useSuccessAnimation,
  LoadingSuccess,
} from "components/common";
import { useParams } from "react-router-dom";
import { ErrorView } from "components/error";
import SupportIssue from "./supportIssue";
import { useSupportService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { ServiceHelper } from "utils/helpers";

const SupportCaseView: React.FC = () => {
  const supportService = useSupportService();
  const urlParams = useParams<EntityIdParams>();
  const id = Number.parseInt(urlParams.id ?? "0");

  const { getMounted } = useMountedState();
  const { goBack } = useNavigationHistory();

  const [notFound, setNotFound] = React.useState<boolean>();
  const [supportIssue, setSupportIssue] = React.useState<WintSuperkollAPIModel.SupportIssue>();
  const [key, setKey] = React.useState(0);

  const { apiRequestKeyRef, updateKey } = useAPIRequestKeyRef();

  const loadSupportIssue = (
    onSuccess?: (incomingInvoice: WintSuperkollAPIModel.SupportIssue) => void,
    onError?: () => void
  ) => {
    const currentKey = updateKey();

    ServiceHelper.withAPIRequestKey(supportService.getById(id), currentKey)
      .then((result) => {
        if (getMounted() && result.key === apiRequestKeyRef.current) {
          setNotFound(false);
          setSupportIssue(result.data);
          setKey(key + 1);
        }

        onSuccess && onSuccess(result.data);
      })
      .catch(() => {
        if (supportIssue) {
          setTimeout(() => {
            goBack();
          }, 1000);
          onError && onError();
        } else setNotFound(true);
      });
  };

  React.useEffect(() => {
    setSupportIssue(undefined);
    loadSupportIssue();
  }, [id]);

  const { showSuccess, onSuccess } = useSuccessAnimation(loadSupportIssue);

  return notFound ? (
    <ErrorView />
  ) : (
    <>
      <PageLayouts.EntityFullScreen
        entityKey={`support-issue`}
        id={supportIssue?.id ?? 0}
        className={clsx(cssExports.transparent, cssExports.cardNavigation)}
      >
        <>
          {showSuccess ? <LoadingSuccess /> : <></>}
          <EntityCardLayout widerCardLayout>
            {supportIssue ? (
              <SupportIssue key={key} supportIssue={supportIssue} reloadHandler={onSuccess} />
            ) : (
              <Skeletons.EntityCardSkeleton />
            )}
          </EntityCardLayout>
        </>
      </PageLayouts.EntityFullScreen>
    </>
  );
};

export default SupportCaseView;
